import React from 'react';
import PropTypes from 'prop-types';

import style from './ImageItem.module.scss';

const ImageItem = props => {
    const { image } = props;

    return (
        <div className={style.el}>
            {image &&
                <span className={style.imgSpan}>
                    <img src={image.url} alt={image.alt} />
                </span>
            }
        </div>
    );
};

ImageItem.propTypes = {
    image: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
};

export default ImageItem;
